import { Modal } from 'react-bootstrap';
import { CalculationNumberModalProps } from './UploadDocument.types';
import { Button } from '../../components/button';
import { useState } from 'react';

export const CalculationNumberModal = ({
	gettingDocumentDigitalCalculator,
	getDocumentDigitalCalculator,
	show,
	onClose,
}: CalculationNumberModalProps) => {
	const [calculationNumber, setCalculationNumber] = useState<string>('');

	const handleCalculationNumberChange = (
		e: React.ChangeEvent<HTMLInputElement>
	) => {
		const value = e.target.value;
		if (value === '' || /^\d+$/.test(value)) {
			setCalculationNumber(value);
		}
	};

	const handleKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
		if (
			!/[0-9]/.test(e.key) &&
			e.key !== 'Backspace' &&
			e.key !== 'Delete' &&
			e.key !== 'ArrowLeft' &&
			e.key !== 'ArrowRight' &&
			e.key !== 'Tab'
		) {
			e.preventDefault();
		}
	};

	return (
		<Modal show={show} animation onHide={onClose}>
			<Modal.Header>
				<h5 className='modal-title' id='Dismiss Modal'>
					Choose an upload method
				</h5>
				<div onClick={onClose}>
					<span className='font-20 cursor-pointer'>&times;</span>
				</div>
			</Modal.Header>
			<Modal.Body className='flex-column gap-2'>
				<input
					type='text'
					className='form-control mb-3'
					placeholder='Enter calculation number'
					value={calculationNumber}
					onChange={handleCalculationNumberChange}
					onKeyPress={handleKeyPress}
					pattern='[0-9]*'
					inputMode='numeric'
				/>
				<Button
					className='btn btn-success d-flex align-items-center justify-content-center'
					onClick={() => {
						const numValue = Number(calculationNumber);
						if (numValue > 0) {
							getDocumentDigitalCalculator({ calculationNumber: numValue });
						}
					}}
					isLoading={gettingDocumentDigitalCalculator}
					loader={{ size: 's', color: 'white' }}
				>
					Load data from Digital Calculator
				</Button>
				<Button className='btn btn-danger' onClick={onClose}>
					Cancel document upload
				</Button>
			</Modal.Body>
		</Modal>
	);
};
